import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import bannerImage22 from "../../assets/images/bannerImage22.png";
import IconBackArrow from "../../assets/images/IconBackArrow.png";
import Button from "@material-ui/core/Button";
import { Link, useHistory } from "react-router-dom";
import success23 from "../../assets/images/success23.png";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(10),
    background: "white",
    borderRadius: "5px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
    marginBottom: "40px",
  },

  marginBottomStyle: {
    marginBottom: "40px",
  },
  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  paddingStyle: {
    padding: "160px",
  },
  centerAlign: {
    textAlign: "center",
  },
  backButton: {
    fontSize: "16px",
    textTransform: "capitalize",
    "&:hover": {
      background: "none",
    },
    color: "#19181699",
  },
}));

const ConfirmDelivery = () => {
  const classes = useStyles();
  const history = useHistory();
  const [confirm, setConfirm] = useState(false);

  const fnConfirm = () => {
    history.push("/home");
  };

  return (
    <>
      {confirm === false && (
        <div>
          <div className={classes.root}>
            <Grid container>
              <Grid item xs={12} className={classes.centerAlign}>
                <img
                  src={success23}
                  alt=""
                  className={classes.marginBottomStyle}
                />
                <Typography
                  variant="body1"
                  className={classes.marginBottomStyle}
                >
                  Cash Out operation was successful
                </Typography>
                {/* <Button
                variant="contained"
                color="primary"
                className={`${classes.buttonStyle} ${classes.marginBottomStyle}`}
                component={Link}
                to="/receiver-authentication"
              >
                Click To Confirm
              </Button> */}
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.buttonStyle}
                  onClick={fnConfirm}
                >
                  Back To Home
                </Button>
              </Grid>
            </Grid>
          </div>
          <Button
            component={Link}
            to="/transfer-receipt"
            className={classes.backButton}
            startIcon={<img src={IconBackArrow} alt="" />}
            disableRipple={true}
          >
            Back
          </Button>
        </div>
      )}

      {confirm && (
        <div className={classes.root}>
          <Grid container className={classes.paddingStyle}>
            <Grid item xs={12} className={classes.centerAlign}>
              <Typography variant="h5" className={classes.marginBottomStyle}>
                Cash Delivered
              </Typography>
              <img src={success23} alt="" />
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
};

export default ConfirmDelivery;
